import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace/$workspaceSlug/settings/")({
  beforeLoad: ({ params }) => {
    // 自动重定向到第一个设置子页面
    throw redirect({
      to: "/workspace/$workspaceSlug/settings/account/profile",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
